import { Accordion } from '@zappyrent/hundop';
import { useTranslation } from 'gatsby-plugin-react-i18next';
import React from 'react';

import {
  StyledFAQSubtitle,
  StyledH3,
} from '../TextPageLandlord/TextPageLandlord.styles';

const FAQ = (): JSX.Element => {
  const { t } = useTranslation(['a11y', 'product']);

  return (
    <>
      <StyledH3 sm="24px" md="24px" lg="24px" tag="h3">
        {t('product:protezioneFaq')}
      </StyledH3>
      <StyledFAQSubtitle tag="strong">
        {t('product:protezioneFaqPrenotazioni')}
      </StyledFAQSubtitle>
      <Accordion
        ariaLabel={t('a11y:showHide')}
        autoClose
        content={[
          {
            title: `${t('product:protezioneFaqQ1')}`,
            body: `${t('product:protezioneFaqA1')}`,
          },
        ]}
        id="faq-accordion0"
      />
      <StyledFAQSubtitle tag="strong">
        {t('product:protezioneFaqPagamenti')}
      </StyledFAQSubtitle>
      <Accordion
        ariaLabel={t('a11y:showHide')}
        autoClose
        content={[
          {
            title: `${t('product:protezioneFaqQ2')}`,
            body: `${t('product:protezioneFaqA2')}`,
          },
          {
            title: `${t('product:protezioneFaqQ3')}`,
            body: `${t('product:protezioneFaqA3')}`,
          },
          {
            title: `${t('product:protezioneFaqQ4')}`,
            body: `${t('product:protezioneFaqA4')}`,
          },
        ]}
        id="faq-accordion1"
      />
      <StyledFAQSubtitle tag="strong">
        {t('product:protezioneFaqContratto')}
      </StyledFAQSubtitle>
      <Accordion
        ariaLabel={t('a11y:showHide')}
        autoClose
        content={[
          {
            title: `${t('product:protezioneFaqQ5')}`,
            body: `${t('product:protezioneFaqA5')}`,
          },
          {
            title: `${t('product:protezioneFaqQ6')}`,
            body: `${t('product:protezioneFaqA6')}`,
          },
          {
            title: `${t('product:protezioneFaqQ7')}`,
            body: `${t('product:protezioneFaqA7')}`,
          },
          {
            title: `${t('product:protezioneFaqQ8')}`,
            body: `${t('product:protezioneFaqA8')}`,
          },
        ]}
        id="faq-accordion2"
      />
      <StyledFAQSubtitle tag="strong">
        {t('product:protezioneFaqTerminiAffitto')}
      </StyledFAQSubtitle>
      <Accordion
        ariaLabel={t('a11y:showHide')}
        autoClose
        content={[
          {
            title: `${t('product:protezioneFaqQ9')}`,
            body: `${t('product:protezioneFaqA9')}`,
          },
          {
            title: `${t('product:protezioneFaqQ10')}`,
            body: `${t('product:protezioneFaqA10')}`,
          },
        ]}
        id="faq-accordion3"
      />
    </>
  );
};

export default FAQ;
